'use client';

import type { ComponentProps } from 'react';
import clsx from 'clsx';
import { Text, type TextProps } from '@frameio/vapor';
import styles from './AssetPathnameSegment.module.css';

export const PathnameSegmentText = ({
  segments = 1,
  ...props
}: { segments?: number } & TextProps) => (
  <div
    className={clsx(
      styles.endPathSegment,
      segments === 2 && styles.withLastPath,
      segments > 2 && styles.withMidPath
    )}
  >
    <Text
      color="tertiary"
      data-pathname-segment={true}
      textAlign="left"
      truncate={{ type: 'middle', padding: 8 }}
      variant="caption"
      {...props}
    />
  </div>
);

export const PathnameSegmentTextMid = (props: TextProps) => (
  <div className={styles.midPathSegment}>
    <Text
      color="tertiary"
      data-pathname-segment={true}
      textAlign="left"
      truncate={true}
      variant="caption"
      {...props}
    />
  </div>
);

export const AssetPathnameContainer = (props: ComponentProps<'div'>) => (
  <div className={styles.container} {...props} />
);

export const Pathnames = (props: ComponentProps<'div'>) => (
  <div className={styles.pathnames} {...props} />
);
